const getCSSVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

const getGradientBackground = (location, isBright) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    let white = getCSSVariable('--main-color-white');
    const yellow = getCSSVariable('--color-yellow');
    let yellow80 = getCSSVariable('--color-yellow-80');
    const red = getCSSVariable('--color-red');
    let red80 = getCSSVariable('--color-red-80');
    const green = getCSSVariable('--color-green');
    let green80 = getCSSVariable('--color-green-80');
    const blue = getCSSVariable('--color-blue');
    let blue80 = getCSSVariable('--color-blue-80');
    if (!isBright) {
        white = getCSSVariable('--main-color-white-darkmode')
        yellow80 = getCSSVariable('--color-yellow-80-black')
        red80 = getCSSVariable('--color-red-80-black')
        blue80 = getCSSVariable('--color-blue-80-black')
        green80 = getCSSVariable('--color-green-80-black')
    }

    if (pathSegments.length === 0) {
        return `linear-gradient(to right, ${white} 0%, ${red80} 80%, ${red} 100%)`;
    }
    const val = pathSegments[0].toLowerCase();

    switch (val) {
        case 'ogs': // Yellow gradient
            return `linear-gradient(to right, ${white} 0%, ${yellow80} 80%, ${yellow} 100%)`;
        case 'gesundheitssport': // Blue gradient
            return `linear-gradient(to right, ${white} 0%, ${blue80} 80%, ${blue} 100%)`;
        case 'erlebnissport': // Green gradient
            return `linear-gradient(to right, ${white} 0%, ${green80} 80%, ${green} 100%)`;
        default: // Default red gradient
            return `linear-gradient(to right, ${white} 0%, ${red80} 80%, ${red} 100%)`;
    }
};

const getBackgroundColor = (location) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
        return getCSSVariable('--color-red');
    }
    const val = pathSegments[0].toLowerCase();
    switch (val) {
        case 'ogs':
            return getCSSVariable('--color-yellow');
        case 'gesundheitssport':
            return getCSSVariable('--color-blue');
        case 'erlebnissport':
            return getCSSVariable('--color-green');
        default:
            return getCSSVariable('--color-red');
    }
}
const get80BackgroundColor = (location) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
        return getCSSVariable('--color-red-80');
    }
    const val = pathSegments[0].toLowerCase();
    switch (val) {
        case 'ogs':
            return getCSSVariable('--color-yellow-80');
        case 'gesundheitssport':
            return getCSSVariable('--color-blue-80');
        case 'erlebnissport':
            return getCSSVariable('--color-green-80');
        default:
            return getCSSVariable('--color-red-80');
    }
}
const getTextColor = (location) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
        return getCSSVariable('--main-color-white');
    }
    const val = pathSegments[0].toLowerCase();
    switch (val) {
        case 'ogs':
            return getCSSVariable('--main-color-black');
        default:
            return getCSSVariable('--main-color-white');
    }
}
const getFooterBackground = (location) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
        return getCSSVariable('--color-red-news-chosen');
    }
    const val = pathSegments[0].toLowerCase();
    switch (val) {
        case 'ogs':
            return getCSSVariable('--color-yellow-news-chosen');
        case 'gesundheitssport':
            return getCSSVariable('--color-blue-news-chosen');
        case 'erlebnissport':
            return getCSSVariable('--color-green-news-chosen');
        default:
            return getCSSVariable('--color-red-news-chosen');
    }
};

export { getFooterBackground, getGradientBackground, getBackgroundColor, get80BackgroundColor, getCSSVariable, getTextColor };